<template>
  <AuthFailure>
    <template #textSlot>
      <h2 style='max-width:460px'>Ваша учетная запись не активна, <br />дождитесь модерации</h2>
    </template>
  </AuthFailure>
</template>

<script>
import AuthFailure from '@/components/view_blocks/Auth_failure/AuthFailure.vue';

export default {
  components: {
    AuthFailure
  },
};
</script>

<style scoped>

</style>
